export const ENDPOINTS = {
  // COOKIE CONSENT
  COOKIE_CONSENT: 'cookie-consent',
  // HOME PAGE
  HOME_PAGE: 'home',

  // TENTANG KAMI
  ABOUT_PAGES: 'about-pages',
  ABOUT_PAGE_BY_SLUG: (slug) => `about-pages/${slug}`,

  // BANNER SLIDER
  BANNER_SLIDER: 'banner-slider',

  // STATISTICS
  STATISTICS: 'statistics',

  // KENAL LEBIH DEKAT
  HERO_SECTION: 'hero-sections',

  // PRODUK & LAYANAN
  SERVICES: 'product-services',
  SERVICES_LIST: 'product-services/list',
  SERVICE_BY_SLUG: (slug) => `product-services/${slug}`,
  SERVICE_ITEM: (slug, item) => `product-services/${slug}/${item}`,
  // VIDEO PRODUCTS
  VIDEO_PRODUCTS: 'product-youtube',

  // TESTIMONIALS
  TESTIMONIALS: 'testimonials',

  //  BERITA
  KATEGORI_BERITA: 'news-categories',
  LIST_BERITA: 'news',
  BERITA_BY_SLUG: (slug) => `news/${slug}`,
  LIST_BERITA_POPULER: 'news/popular',
  LIST_BERITA_TERBARU: 'news/recent',

  // MITRA
  PARTNERS: 'partners',

  // ALAMAT KANTOR
  ALAMAT_KANTOR: 'office-locations',

  // LOKER
  LOKER: 'job-vacancies',
};
